(function (angular) {
  "use strict";

  var HIDE_LOADING_OVERLAY_DELAY_MS = 200;

  angular.module("Toyota.Directives").directive("tyPricingCta", [
    "DebugLogger",
    function (DebugLogger) {
      function handleReject(error) {
        DebugLogger.log("tyPricingCta", error);
      }

      var controller = [
        "$scope",
        "$element",
        "$timeout",
        function ($scope, $element, $timeout) {
          var $loadingOverlay = $element.find(".ty-pricing-cta__loading-spinner");

          function init() {
            $scope.dealerInventory = $scope.dealerInventory ? $scope.dealerInventory : {};
          }

          $scope.$on("pricing-page-material-code", function (event, materialCodePromise) {
            showLoadingOverlay();

            materialCodePromise
              .then(function () {
                $timeout(function () {
                  if (!$scope.dealerInventory.loading) {
                    hideLoadingOverlay();
                  }
                }, HIDE_LOADING_OVERLAY_DELAY_MS);
              })
              .catch(handleReject);
          });

          $scope.$watch("dealerInventory.loading", function () {
            if (!$scope.dealerInventory.loading) {
              hideLoadingOverlay();
            } else {
              showLoadingOverlay();
            }
          });

          function showLoadingOverlay() {
            $loadingOverlay.addClass("is-loading");
          }

          function hideLoadingOverlay() {
            $loadingOverlay.removeClass("is-loading");
          }

          this.$onInit = init;
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "pricingCtaController",
      };
    },
  ]);
})(window.angular);
